import { Session } from "types/session";
import client from "./client";
import { LazyData, LazyFilters } from "types/datacontext";

export const fetchSession = async ({
  id
}: Partial<Session>): Promise<Session> => {
  return client.get(`/sessions/${id}`).then(response => response.data.response);
};


export const fetchSessions = async (page = 0, pageSize = 10, owned?: boolean, order?: Array<string>, filters?: Array<Object>, search?: string): Promise<LazyData<Session>> => {
  const params = {
    page: page,
    //order: ["start_time", "DESC"],
    order: order,
    ...(owned && { owned: `${owned}` }),
    filters: filters,
    search: search,
    limit: pageSize
  };
  return client
    .get("/sessions", { params })
    .then(response => response.data.response);
};

export const fetchFilters = async ( owned = true): Promise<LazyFilters> => {
  const params = { owned };
  return client
    .get("/sessions/filter", { params })
    .then(response => response.data.response);
};

export const fetchCalendar = async ( start_time_range: string | Date, end_time_range: string | Date): Promise<Session[]> => {
  return client
    .get('/sessions/calendar', { params: {start_time_range, end_time_range} })
    .then(response => response.data.response);
};

export const createSession = async (
  data: Partial<Session>
): Promise<Session> => {
  return client
    .post("/sessions/create", { ...data })
    .then(response => response.data.response);
};

export const updateSession = async ({
  id,
  ...data
}: Partial<Session>): Promise<Session> => {
  return client
    .post(`/sessions/update/${id}`, { ...data })
    .then(response => response.data.response);
};

export const cancelSession = async ({
  id,
  noShow = false
}: Partial<Session> & { noShow?: boolean }): Promise<Session> => {
  return client
    .post(`/sessions/cancel/${id}`, { noShow })
    .then(response => response.data.response);
};

export const completeSession = async ({
  id
}: Partial<Session>): Promise<Session> => {
  return client
    .post(`/sessions/complete/${id}`)
    .then(response => response.data.response);
};

export const joinSession = async (id: string): Promise<string> => {
  return client
    .get(`/sessions/join/${id}`)
    .then(response => response.data.response.twilio_token);
};

